import React, { Dispatch, SetStateAction, useEffect, useMemo, useState } from "react";
export interface DebugContextValue {
	debugMode: number;
	setDebugMode: Dispatch<SetStateAction<number>>;
}

const DEBUG_MODE_KEY = "CFG_DEBUG_MODE";

export enum DebugMode {
	DebugOff = 0,
	DebugLimited = 1,
	DebugExtended = 2,
}

export const DebugContext = React.createContext<DebugContextValue | undefined>(undefined);

export const DebugWrapper: React.FC = (props) => {
	const showDebug = localStorage.getItem(DEBUG_MODE_KEY);

	let localStorageDebugMode = DebugMode.DebugOff;

	if (showDebug !== null) {
		const asInt = parseInt(showDebug);
		if (isFinite(asInt)) {
			localStorageDebugMode = asInt;
		}
	}

	const [debugMode, setDebugMode] = useState<DebugMode>(localStorageDebugMode);

	useEffect(() => localStorage.setItem(DEBUG_MODE_KEY, `${debugMode}`), [debugMode]);

	const debugContextValue = useMemo<DebugContextValue>(
		() => ({
			debugMode,
			setDebugMode,
		}),
		[debugMode]
	);

	return (
		<DebugContext.Provider value={debugContextValue}>{props.children}</DebugContext.Provider>
	);
};
